"use strict";
/**
 * @file Created on 24.07.2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var utils_1 = require("../../../../core/utils");

var StoreSpecificationEnum_1 = require("../../../../promotion/model/StoreSpecificationEnum");

var UserInfoConverter_1 = require("../../../../user/conversions/UserInfoConverter");

var WindowStateEnum_1 = require("../../../../window/model/WindowStateEnum");

var NWindowWrapper_1 = require("../../model/wrappers/NWindowWrapper");

var NotificationDocConverter_1 = require("../../NotificationDocConverter");

var NWindowWrapperConverter_1 = require("./NWindowWrapperConverter");
/**
 * @author Tomas Leity
 */


var NWindowWrapperConverterImpl =
/*#__PURE__*/
function (_NWindowWrapperConver) {
  _inherits(NWindowWrapperConverterImpl, _NWindowWrapperConver);

  /**
   * @param userInfoConverter
   */
  function NWindowWrapperConverterImpl(userInfoConverter) {
    var _this;

    _classCallCheck(this, NWindowWrapperConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(NWindowWrapperConverterImpl).call(this));
    _this.userInfoConverter = userInfoConverter;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(NWindowWrapperConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      var _this2 = this;

      var document = null;

      if (!utils_1.Utils.isValueMissing(source.documentType)) {
        var converter = typescript_ioc_1.Container.get(NotificationDocConverter_1.NotificationDocConverter, {
          documentType: source.documentType
        });
        document = converter.toObject(source.document, conversions);
      }

      return new NWindowWrapper_1.NWindowWrapper(conversions.toClassReferenceId(source.promoId), source.promoName, source.promoExternalId, conversions.toDate(source.promoDateFrom), conversions.toDate(source.promoDateTo), source.promoStartWeek, conversions.asEnum(source.promoStoreSpecification, StoreSpecificationEnum_1.StoreSpecificationEnum), conversions.toClassReferenceId(source.id), source.name, source.externalId, conversions.asEnum(source.workflowState, WindowStateEnum_1.WindowStateEnum), conversions.toClassReferenceId(source.windowTypeId), source.windowType, conversions.toClassReferenceId(source.portfolioId), source.portfolio, source.themeId ? conversions.toClassReferenceId(source.themeId) : null, source.theme, conversions.toDate(source.dateFrom), conversions.toDate(source.dateTo), source.priceValidityStart ? conversions.toDate(source.priceValidityStart) : null, source.priceValidityEnd ? conversions.toDate(source.priceValidityEnd) : null, source.startWeek, conversions.asObject(source, 'ownedBy', function (obj) {
        return _this2.userInfoConverter.toObject(obj, conversions);
      }), source.documentType, document);
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      var _this3 = this;

      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var document = null;

      if (!utils_1.Utils.isValueMissing(source.documentType)) {
        var converter = typescript_ioc_1.Container.get(NotificationDocConverter_1.NotificationDocConverter, {
          documentType: source.documentType
        });
        document = converter.toDocument(source.document, conversions);
      }

      var result = {};
      Object.assign(result, {
        promoId: conversions.toDocumentReferenceId(source.promoId),
        promoName: source.promoName,
        promoExternalId: source.promoExternalId,
        promoDateFrom: conversions.fromDate(source.promoDateFrom),
        promoDateTo: conversions.fromDate(source.promoDateTo),
        promoStartWeek: source.promoStartWeek,
        promoStoreSpecification: source.promoStoreSpecification,
        id: conversions.toDocumentReferenceId(source.id),
        name: source.name,
        externalId: source.externalId,
        workflowState: source.workflowState,
        windowTypeId: conversions.toDocumentReferenceId(source.windowTypeId),
        windowType: source.windowType,
        portfolioId: conversions.toDocumentReferenceId(source.portfolioId),
        portfolio: source.portfolio,
        themeId: source.themeId ? conversions.toDocumentReferenceId(source.themeId) : null,
        theme: source.theme,
        dateFrom: conversions.fromDate(source.dateFrom),
        dateTo: conversions.fromDate(source.dateTo),
        priceValidityStart: source.priceValidityStart ? conversions.fromDate(source.priceValidityStart) : null,
        priceValidityEnd: source.priceValidityEnd ? conversions.fromDate(source.priceValidityEnd) : null,
        startWeek: source.startWeek,
        ownedBy: conversions.asObject(source, 'ownedBy', function (obj) {
          return _this3.userInfoConverter.toDocument(obj, conversions);
        }),
        documentType: source.documentType,
        document: document
      });
      return result;
    }
  }]);

  return NWindowWrapperConverterImpl;
}(NWindowWrapperConverter_1.NWindowWrapperConverter);
/**
 * IOC Container qualifier
 */


NWindowWrapperConverterImpl.QUALIFIER = {
  documentType: NWindowWrapper_1.NWindowWrapper.name
};
NWindowWrapperConverterImpl = __decorate([__param(0, typescript_ioc_1.Inject), __metadata("design:paramtypes", [UserInfoConverter_1.UserInfoConverter])], NWindowWrapperConverterImpl);
exports.NWindowWrapperConverterImpl = NWindowWrapperConverterImpl;